import { useCallback, useMemo, useState } from "react"

import { InfoOutlineIcon } from "@l2r-front/l2r-icons"
import { PropTypes } from "@l2r-front/l2r-proptypes"
import { FormControl, MenuItem, Typography, useIsMobileDevice } from "@l2r-front/l2r-ui"

import { useMapContext } from "../../contexts/MapContext"

import * as Styled from "./MapLegend.styled"

export function MapLegend(props) {

    const {
        displayedLegends,
    } = props
    const [mapState, mapDispatch] = useMapContext()

    const { legendOpened } = mapState
    const { toggleLegendOpening } = mapDispatch
    const [selectedLegendIndex, setSelectedLegendIndex] = useState(0)
    const isMobile = useIsMobileDevice()

    const selectOptions = useMemo(() => {
        return displayedLegends.map((v, index) => <MenuItem key={`select-option-${index}`} value={index}>
            {v.layerName}
        </MenuItem>)
    }, [displayedLegends])

    const Title = useMemo(() => {
        return displayedLegends.length > 1 ? () => <FormControl fullWidth>
            <Styled.Select
                noMargin
                onChange={(event) => setSelectedLegendIndex(event.target.value)}
                value={selectedLegendIndex}
                valueVariant="H4"
            >
                {selectOptions}
            </Styled.Select>
        </FormControl> : () => <Styled.TitleWrapper>
            <Typography id="map-legend-title" variant="H4">
                {displayedLegends?.[0]?.title}
            </Typography>
        </Styled.TitleWrapper>
    }, [displayedLegends, selectOptions, selectedLegendIndex])

    const displayLabel = useCallback((label) => {
        if (Array.isArray(label)) {
            return <Styled.LabelWrapper>
                {
                    label.map((labelValue => {
                        return <Styled.Label variant="Regular">{labelValue}</Styled.Label>
                    }))
                }
            </Styled.LabelWrapper>
        }
        return <Styled.Label variant="Regular">{label}</Styled.Label>
    }, [])

    if (!legendOpened) {
        return <Styled.Button
            color="cta-bg/cta-bg-primary"
            id="map-legend-open-button"
            onClick={toggleLegendOpening}
        >
            <InfoOutlineIcon />
        </Styled.Button>
    }

    return <Styled.LegendWrapper id="map-legend" isMobile={isMobile} >
        <Styled.LegendHeader>
            <Title />
            <Styled.IconButton id="map-legend-close-button" onClick={toggleLegendOpening}>
                <Styled.CloseIcon />
            </Styled.IconButton>
        </Styled.LegendHeader>
        <Styled.OverflowWrapper>
            {displayedLegends[selectedLegendIndex].legendData.map((item, index) => {
                return <Styled.ItemWrapper
                    id={`map-legend-item-${index}`}
                    key={`legend-${index}`}
                    last={(index + 1) === displayedLegends[selectedLegendIndex].legendData.length}
                >
                    <Styled.Color color={item.color} />
                    {displayLabel(item.label)}
                </Styled.ItemWrapper>
            })}
        </Styled.OverflowWrapper>
    </Styled.LegendWrapper>
}

MapLegend.propTypes = {
    displayedLegends: PropTypes.arrayOf(
        PropTypes.shape({
            layerName: PropTypes.string.isRequired,
            legendData: PropTypes.arrayOf(
                PropTypes.shape({
                    color: PropTypes.string.isRequired,
                    label: PropTypes.oneOfType([
                        PropTypes.string.isRequired,
                        PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
                    ]).isRequired,
                }).isRequired,
            ).isRequired,
        }).isRequired,
    ).isRequired,
}